import { logParamKey, Route, ticketParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'
import { CompanyTicketRouteName } from '@/views/company/ticket/routes'

export enum TicketRouteName {
    Edit = 'tickets.edit',
    Index = 'tickets.index',
    Triage = 'tickets.triage',
    Details = 'ticket.details',
    Attachments = 'ticket.attachments',
    Services = 'ticket.services',
    Articles = 'ticket.articles',
    Assets = 'ticket.assets',
    Mine = 'tickets.mine',
    Logs = 'ticket.logs',
    LogDetails = 'tickets.logs.details',
    ResourceIndex = 'tickets.resources.index',
    ResourceCreate = 'tickets.resources.create',
    ResourceEdit = 'tickets.resources.edit',
}

export const setRouteQueries = async (route: Route) => {
    if (route.name.value !== CompanyTicketRouteName.Index) {
        await route.addFilter({
            column: 'status_name',
            operator: '!=',
            value: 'closed',
        })
    }

    if (route.name.value === CompanyTicketRouteName.Index) {
        route.limit.value = 40
    }

    await route.addSortItem({
        column: 'status_priority',
        direction: 'asc',
    })

    if (route.name.value === TicketRouteName.Index) {
        await route.addSortItem({
            column: 'priority_number',
            direction: 'asc',
        })
    }

    await route.addSortItem({
        column: 'updated_at',
        direction: 'desc',
    })

    route.view.value = 'flat'
}

export default {
    path: '/tickets',
    component: () => import('./Index.vue'),
    name: 'tickets',
    meta: {
        label: 'Tickets',
        permission: Permission.TicketViewAny,
        auth: true,
    },
    children: [
        {
            path: '',
            name: TicketRouteName.Index,
            component: () => import('./Tickets.vue'),
            meta: {
                label: 'Tickets',
                auth: true,
                permission: Permission.TicketViewAny,
            },
        },
        {
            path: 'create',
            name: 'tickets.create',
            component: () => import('./CreateForm.vue'),
            meta: {
                label: 'Create Ticket',
                auth: true,
                permission: 'manage-tickets',
            },
        },
        {
            path: `:${ticketParamKey}/details`,
            name: TicketRouteName.Details,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Details',
                auth: true,
                permission: Permission.TicketView,
            },
        },
        {
            path: `:${ticketParamKey}/attachments`,
            name: TicketRouteName.Attachments,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Attachments',
                auth: true,
                permission: Permission.TicketView,
            },
        },
        {
            path: `:${ticketParamKey}/services`,
            name: TicketRouteName.Services,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Services',
                auth: true,
                permission: Permission.TicketView,
            },
        },
        {
            path: `:${ticketParamKey}/articles`,
            name: TicketRouteName.Articles,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Articles',
                auth: true,
                permission: Permission.TicketView,
            },
        },
        {
            path: `:${ticketParamKey}/assets`,
            name: TicketRouteName.Assets,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Assets',
                auth: true,
                permission: Permission.TicketView,
            },
        },
        {
            path: `:${ticketParamKey}/edit`,
            name: TicketRouteName.Edit,
            component: () => import('./Tickets.vue'),
            meta: {
                label: 'Edit Ticket',
                auth: true,
                permission: 'ticket:update',
            },
        },
        {
            path: `:${ticketParamKey}/logs`,
            name: TicketRouteName.Logs,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: TicketRouteName.LogDetails,
                    component: () => import('./Tickets.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
        {
            path: ':ticketId/resources',
            name: TicketRouteName.ResourceIndex,
            component: () => import('./Details.vue'),
            meta: {
                label: 'Ticket Resources',
                auth: true,
                permission: 'manage-tickets',
            },
            children: [
                {
                    path: 'create',
                    name: TicketRouteName.ResourceCreate,
                    component: () => import('./Details.vue'),
                    meta: {
                        label: 'Create Ticket Resource',
                        auth: true,
                        permission: 'manage-tickets',
                        parent: 'tickets.resources.index',
                    },
                },
                {
                    path: ':resourceId/edit',
                    name: TicketRouteName.ResourceEdit,
                    component: () => import('./Details.vue'),
                    meta: {
                        label: 'Edit Ticket Resource',
                        auth: true,
                        permission: 'manage-tickets',
                        parent: 'tickets.resources.index',
                    },
                },
            ],
        },
    ],
}
